import { BREAKPOINTS } from '../../services/responsive.service';

/**
 * AG-Grid Global Configuration
 * ============================
 * Central place to configure AG-Grid settings used across the application.
 *
 * Change values here to update all grids throughout the app.
 * Row heights are responsive - smaller on small screens (< 1536px).
 *
 * Note: These getters check screen width at access time. Grids read these
 * values during initialization, so new grids will use the correct size
 * for the current viewport.
 */

export const GRID_CONFIG = {
  /**
   * Default row height in pixels.
   * Used by ag-grid-wrapper and standalone ag-grid instances.
   *
   * Large screens (>= 1536px): 42px
   * Small screens (< 1536px): 32px (compact/dense)
   */
  get ROW_HEIGHT(): number {
    return window.innerWidth < BREAKPOINTS['2xl'] ? 32 : 42;
  },

  /**
   * Header height in pixels.
   * Large screens: 48px
   * Small screens: 38px
   */
  get HEADER_HEIGHT(): number {
    return window.innerWidth < BREAKPOINTS['2xl'] ? 38 : 48;
  },

  /**
   * Minimum row height (for auto-height rows)
   */
  MIN_ROW_HEIGHT: 40,

  /**
   * Row height for detail/expanded rows
   */
  DETAIL_ROW_HEIGHT: 300,
};

/**
 * Type for GRID_CONFIG for type safety
 */
export type GridConfig = typeof GRID_CONFIG;
